/**
 * @file 快速上手
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

import PictureCardGroup from '../../../../components/picture-card/PictureCardGroup';
import {IPictureCard} from '../../../../components/picture-card/PictureCard';

interface IProps {
    caseList: IPictureCard[];
}

const CaseList: React.FC<IProps> = props => {
    return (
        <PictureCardGroup
            className="paddle-case-list"
            option={props.caseList}
        />
    );
};

export default CaseList;
